import React from "react";
import { Skills, SkillsContainer } from "../styles/about";
import { LinearLine } from "../styles/porfolio";
import { WindowBlack } from "../styles/home";
import skills from "../data/skills.json";

const Skill = () => {
  return (
    <WindowBlack>
      <SkillsContainer>
        <h1>My Skills</h1>
        <LinearLine />
        <Skills>
          {skills.map((skill) => (
            <div key={skill.id}>{skill.name}</div>
          ))}
        </Skills>
      </SkillsContainer>
    </WindowBlack>
  );
};

export default Skill;
